module.exports = __webpack_public_path__ + "img/ico_power.92c8eb6d.png";